export { default } from './ResetPassword'


// WEBPACK FOOTER //
// ./src/scenes/ResetPassword/index.js